import React from 'react';
import { connect } from "react-redux";
import { withNamespaces } from 'react-i18next';
import Tabs from './tabs'
import './main.scss'

export class Main extends React.Component{
    render(){       
        return(    
            <main className="scrollbar-hidden">                
                <Tabs />
            </main>      
        )
    }  
}

const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};  
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(Main));
